const PreferredContactMethod = {
  Axiom: 'Axiom',
  Personal: 'Personal',
  Both: 'Both',
} as const;

export const CandidateContactInformationConst = {
  PreferredContactMethod,
} as const;
